export default "__VITE_ASSET__Cg7KiMS2__"